import React, { useCallback, useContext, useState } from 'react';
import MuroIcon from '@wix/da-ds/pkg/Icons/MuroCommentIcon';
import { useTranslation } from 'react-i18next';
import EditorIconButton from '../_partials/EditorIconButton';
import Headerless from '@wix/da-ds/pkg/modals/dsPresets/HeaderlessModal/HeaderlessModal';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import { useFlag } from '@wix/da-react-context/pkg/flags/hooks';
const X_RESET_TIME = 1000;
const MuroComment = ({ editor, hideWhenNotEnabled = true })=>{
    var _editor_storage_daextrenderers, _editor_storage;
    const { t } = useTranslation('editor');
    const isMobile = useContext(MobileContext);
    const hasMobileFeature = useFlag('mobile_muro');
    const [showMuroPopup, setShowMuroPopup] = useState(false);
    const hideMuroPopup = useCallback(()=>{
        setShowMuroPopup(false);
    }, [
        setShowMuroPopup
    ]);
    const openMuroModal = useCallback(()=>{
        setShowMuroPopup(true);
    }, [
        setShowMuroPopup
    ]);
    const useDrawing = useCallback((deviation)=>{
        editor.commands.daMuroUseDrawing(deviation);
    }, [
        editor
    ]);
    const [closeRequested, setCloseRequested] = useState(false);
    const doClose = useCallback(()=>{
        hideMuroPopup();
    }, [
        hideMuroPopup
    ]);
    const handleClose = useCallback(()=>{
        setCloseRequested(true);
        // This timeout is to "reset" the x button, so if the close gets cancelled the
        // user can try to close again later
        setTimeout(()=>{
            setCloseRequested(false);
        }, X_RESET_TIME);
    }, [
        setCloseRequested
    ]);
    if (isMobile && !hasMobileFeature) {
        return null;
    }
    if (!(editor === null || editor === void 0 ? void 0 : (_editor_storage = editor.storage) === null || _editor_storage === void 0 ? void 0 : (_editor_storage_daextrenderers = _editor_storage['da-ext-renderers']) === null || _editor_storage_daextrenderers === void 0 ? void 0 : _editor_storage_daextrenderers.muroMicro)) {
        return null;
    }
    const Micro = editor.storage['da-ext-renderers'].muroMicro;
    const MobileMuro = editor.storage['da-ext-renderers'].muroMobile;
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(EditorIconButton, {
        featureId: "node:micromuro",
        tooltipText: t('button.micromuro.tooltip'),
        "aria-label": t('button.micromuro.tooltip'),
        icon: MuroIcon,
        onClick: openMuroModal
    }), showMuroPopup && !isMobile && /*#__PURE__*/ React.createElement(Headerless, {
        useFixedMobileHeight: true,
        isOpen: true,
        hasCloseButton: true,
        onRequestClose: handleClose
    }, /*#__PURE__*/ React.createElement(Micro, {
        handleUseDrawing: useDrawing,
        onRequestClose: doClose,
        closeRequested: closeRequested
    })), showMuroPopup && isMobile && /*#__PURE__*/ React.createElement(Headerless, {
        useFixedMobileHeight: true,
        isOpen: true,
        hasCloseButton: true,
        onRequestClose: handleClose
    }, /*#__PURE__*/ React.createElement(MobileMuro, {
        handleUseDrawing: useDrawing,
        onRequestClose: doClose,
        closeRequested: closeRequested
    })));
};
MuroComment.displayName = 'MuroComment';
export default MuroComment;

//# sourceMappingURL=MuroComment.js.map